// src/pages/ModuleDetailPage.jsx
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getModuleById, getNextRecommendedModule } from '../data/modules';
import { useGamificationStore } from '../stores/gamificationStore';
import RelationshipModuleDetail from '../components/modules/RelationshipModuleDetail';
import { setReadingModule, clearReadingModule } from '../services/coachModuleContext';

const ModuleDetailPage = () => {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const module = getModuleById(moduleId);

  // While this page is open, the menu links into the coach tell it which
  // module the person is reading.
  const readingId = module?.id;
  const readingTitle = module?.title;
  useEffect(() => {
    if (!readingId) return undefined;
    setReadingModule({ id: readingId, title: readingTitle });
    return () => clearReadingModule(readingId);
  }, [readingId, readingTitle]);
  const completedModules = useGamificationStore((state) => state.completedModules);

  const handleModuleComplete = () => {
    // Get the next recommended module based on completed modules
    const nextModule = getNextRecommendedModule(completedModules);

    if (nextModule) {
      // Navigate to the next module
      console.log(`Navigating to next module: ${nextModule.id}`);
      navigate(`/modules/${nextModule.id}`);
    } else {
      // All modules complete - navigate back to modules page
      console.log('All modules complete! Returning to modules page');
      navigate('/modules');
    }
  };

  if (!module) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-32 pb-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold text-white mb-4">Module Not Found</h1>
          <p className="text-slate-300 mb-8">The module you're looking for doesn't exist.</p>
          <button
            onClick={() => navigate('/modules')}
            className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:scale-105 transition-transform"
          >
            Back to Modules
          </button>
        </div>
      </div>
    );
  }

  return (
    <RelationshipModuleDetail
      module={module}
      onComplete={handleModuleComplete}
      onBack={() => navigate('/modules')}
    />
  );
};

export default ModuleDetailPage;
